import React from "react";
import { Col, Row } from "react-bootstrap";

import FeatureImage from "../../assets/images/Home/Features/leftaddimage.png";

const Feature = () => {
  const features = [
    {
      title: "Scan & Save Business Cards",
      description:
        "Instantly digitize your contacts with AI-powered scanning.",
      id: 1,
    },
    {
      title: "Digital Business Card Creation",
      description:
        "Customize professional cards with stunning templates.",
      id: 2,
    },
    {
      title: "Seamless Roli-Card Integration",
      description:
        "Organize your contacts in a structured digital Rolodex.",
      id: 3,
    },
    {
      title: "QR Code Sharing ",
      description:
        "Generate and share digital cards with a simple scan.",
      id: 4,
    },
    {
      title: "Networking & Invitations",
      description:
        "Connect with professionals and schedule meetings with ease.",
      id: 5,
    },
    {
      title: "Cloud Backup & Sync ",
      description:
        "Never lose your contacts with secure cloud storage.",
      id: 6,
    },
    {
      title: "Privacy & Security",
      description:
        "Advanced encryption keeps your information safe.",
      id: 7,
    },
  ];
  return (
    <>
      <div className="features-component container" id="feature">
        <Row>
          <Col className="feature-image mt-5" xs={12} md={12} lg={6}>
            <img src={FeatureImage} alt="" />
          </Col>
          <Col className="feature-details mt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              {/* <h5>Features</h5> */}
              <h1>
                Key <span>Features</span>
              </h1>
              <div className="feature-list mt-5">
                {features.map((feature, index) => (
                  <div key={feature.id} className="feature-item mb-3">
                    <input
                      type="radio"
                      id={`feature${index}`}
                      name="feature"
                      defaultChecked={index === 1}
                    />
                    <label htmlFor={`feature${index}`}>
                      <h3>{feature.title}</h3>
                      <p className="mb-2">{feature.description}</p>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Feature };
